/*
 Help track time lapse - tells you the time difference between each "check()" and since the "start()"
*/
export default class TimeTracker {
    constructor() {
        this.startTime = new Date().getTime();
        this.now = this.start;
    }

    start() {
        this.startTime = new Date().getTime();
    }

    check() {
        this.now = new Date().getTime();
        // console.log(message, 'time elapsed:', now - start);//uncomment this in dev or debug mode
    }
}
